import { SharedModule } from 'app/components/shared/shared.module';

import { FingerprintAIO } from '@awesome-cordova-plugins/fingerprint-aio/ngx';
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";

import { IonicGestureConfig } from './utility/IonicGestureConfig';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';


import { BaseComponent } from './base.component';

import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule, Title } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicRouteStrategy, IonicModule } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { CacheService } from './services/cache.service';
import { GeneralService } from './services/general.service';
import { VehicleService } from './services/vehicle.service';
import { ExportService } from './services/export.service';

import { AuthGuardService } from './services/auth-guard.service';
import { environment } from '../environments/environment';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './interceptors/token.interceptor';

import { DecimalPipe } from '@angular/common';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CheckForUpdateService } from './services/check-for-update.service';
import { IonicStorageModule } from '@ionic/storage-angular';
import { NgChartsModule } from 'ng2-charts';

import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { MenusModule } from 'app/components/menus/menus.module';

@NgModule({
    declarations: [
        AppComponent,
        // SidewaysnavComponent,
        BaseComponent
    ],
    exports: [],
    bootstrap: [
        AppComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        MenusModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.serviceWorker }),
        IonicModule.forRoot({
            mode: 'md',
            statusTap: true,
            swipeBackEnabled: true,
            navAnimation: customTransition,
            innerHTMLTemplatesEnabled: true
        }),
        IonicStorageModule.forRoot(),
        HammerModule,
        NgChartsModule
    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        AuthGuardService,
        RightsResolver,
        CacheService,
        GeneralService,
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        VehicleService,
        DecimalPipe,
        ExportService,
        Title,
        BaseComponent,
        CheckForUpdateService,
        ScreenOrientation,
        FingerprintAIO,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: IonicGestureConfig
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule { }

import { iosTransitionAnimation, Animation, mdTransitionAnimation } from '@ionic/core';
import { RightsResolver } from './resolvers/rights.resolver';

export const TRANSITION_HORIZONTAL = 'attr.data-transition-horizontal';
export const ROUTER_TRANSITION_HORIZONTAL = 'data-transition-horizontal';

//refer https://medium.com/@hanche2001/how-to-change-between-android-and-ios-page-transitions-dynamically-in-ionic-ec1256a692f5
export function customTransition(navEl, opts): Animation
{
    return iosTransitionAnimation(navEl, opts);
}
